
// @ts-nocheck
import locale_C_58_C_58_Users_Administrator_Desktop_new_website_nuxt3Template_master_locales_zh_CN_json from "../locales/zh-CN.json";
import locale_C_58_C_58_Users_Administrator_Desktop_new_website_nuxt3Template_master_locales_en_US_json from "../locales/en-US.json";


export const localeCodes =  [
  "zh-CN",
  "en-US"
]

export const localeLoaders = {
  "zh-CN": [{ key: "../locales/zh-CN.json", load: () => Promise.resolve(locale_C_58_C_58_Users_Administrator_Desktop_new_website_nuxt3Template_master_locales_zh_CN_json), cache: true }],
  "en-US": [{ key: "../locales/en-US.json", load: () => Promise.resolve(locale_C_58_C_58_Users_Administrator_Desktop_new_website_nuxt3Template_master_locales_en_US_json), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "zh-CN",
      "name": "简体中文",
      "language": "zh-CN",
      "files": [
        "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/locales/zh-CN.json"
      ]
    },
    {
      "code": "en-US",
      "name": "English",
      "language": "en-US",
      "files": [
        "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/locales/en-US.json"
      ]
    }
  ],
  "defaultLocale": "zh-CN",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "locales/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "zh-CN",
    "name": "简体中文",
    "language": "zh-CN",
    "files": [
      {
        "path": "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/locales/zh-CN.json"
      }
    ]
  },
  {
    "code": "en-US",
    "name": "English",
    "language": "en-US",
    "files": [
      {
        "path": "C:/Users/Administrator/Desktop/new_website/nuxt3Template-master/locales/en-US.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
